/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./MetricCollector.styled";
import { formatIntlNumber } from "../../../../utils/Helpers";
import { ActionsDataViz } from "../../../../Actions/ActionsDataViz/ActionsDataViz";

const MetricCollector = ({ title, value, unit = "", type = null, language, children }) => {
  const { t } = useTranslation();

  const [showBlink, setShowBlink] = useState(false);

  const isEmptyValue = value == null || value == 0;
  const emptyValue = "--";
  const points = unit === "%" ? 2 : 0;
  const metricValue = isEmptyValue ? emptyValue : formatIntlNumber(value, { language, points });

  useEffect(() => {
    setShowBlink(false);

    const blinkTimeout = setTimeout(() => {
      setShowBlink(true);
    }, 10);

    return () => {
      clearTimeout(blinkTimeout);
    };
  }, [value]);

  const handleShowAttentionBox = () => {
    ActionsDataViz.metricHovered(type);
  };

  return (
    <SC.Wrapper onMouseEnter={handleShowAttentionBox}>
      <SC.Title>{t(title)}</SC.Title>
      <SC.Body>
        <SC.Value isEmptyValue={isEmptyValue} showBlink={showBlink}>
          {metricValue}
        </SC.Value>
        {!isEmptyValue ? <SC.Unit>{unit}</SC.Unit> : null}
      </SC.Body>
      <SC.Children>{children}</SC.Children>
    </SC.Wrapper>
  );
};
export default MetricCollector;
